/* eslint-disable no-console */
import React, { useEffect, useMemo } from 'react';

import { useAuthContext } from '../../context/auth/auth-context';
import { Routes } from '../../app/Routes';
import { Unauthenticated } from '../Unauthenticated/Unauthenticated';
import i18next from '../../i18n';
export const tryingToFetchTheUserTestId = 'tryingToFetchTheUserTestId';
export const noUserTestId = 'noUserTestId';

export const AuthGuard = () => {
  console.log('Inside Auth Guard');
  const { userTokenData, triedToFetchTheUser } = useAuthContext();
  const { isRenderedByContainer } = window;
  console.log(
    'Inside Auth Guard userdata and userTokenData',
    triedToFetchTheUser,
    userTokenData
  );

  useEffect(() => {
    const language: any = window.sessionStorage.getItem('language');

    i18next.changeLanguage(language);
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fallback = isRenderedByContainer ? (
    <div data-testid={noUserTestId} />
  ) : (
    <Unauthenticated />
  );

  return useMemo(() => {
    if (triedToFetchTheUser) {
      return <>{userTokenData ? <Routes /> : fallback}</>;
    }

    return <div data-testid={tryingToFetchTheUserTestId} />;
  }, [userTokenData, triedToFetchTheUser, fallback]);
};
